import { CallApi, handleJSONResponse, handleResponse } from './common';
import { TracInvite, NewTracInvite } from '@services/invites/types/trac-invite';
import { CreateInvitesRequest } from '@services/invites/types/api/create-invites-request';
import { TracInviteTypes } from '@services/invites/types/invite-types';
import SimpleArtist from '../../../../common/types/artist/simple-artist';

const callAPI = CallApi('invites');

export const listInvites = async (
  inviterId: string,
  type: TracInviteTypes
): Promise<TracInvite[]> => {
  const response = await callAPI(`/${inviterId}/list/${type}`, 'GET');

  return await handleJSONResponse(response);
};

export const listUserInvites = async (
  type?: TracInviteTypes
): Promise<TracInvite[]> => {
  const url = type ? `/?type=${type}` : '/';
  const response = await callAPI(url, 'GET');

  return await handleJSONResponse(response);
};

export const listRecordLabelInvites = async (
  recordLabelId: string,
  type: TracInviteTypes
): Promise<TracInvite[]> => {
  const response = await callAPI(
    `/record-labels/${recordLabelId}/${type}`,
    'GET'
  );

  return await handleJSONResponse(response);
};

export const createInvites = async (
  artist: SimpleArtist,
  invites: NewTracInvite[]
): Promise<TracInvite[]> => {
  const payload: CreateInvitesRequest = {
    invites,
    artist,
  };

  const response = await callAPI(`/${artist.id}`, 'POST', payload);

  return await handleJSONResponse(response);
};

export const cancelInvite = async (
  artistId: string,
  inviteId: string
): Promise<any> => {
  const response = await callAPI(`/${artistId}/${inviteId}`, 'DELETE');

  return await handleResponse(response);
};

export const acceptInvite = async (
  artistId: string,
  inviteId: string
): Promise<any> => {
  const response = await callAPI(`/${artistId}/${inviteId}/accepted`, 'POST');

  return await handleResponse(response);
};

export const rejectInvite = async (
  artistId: string,
  inviteId: string
): Promise<any> => {
  const response = await callAPI(`/${artistId}/${inviteId}/rejected`, 'POST');

  return await handleResponse(response);
};

export const resendInvite = async (
  artistId: string,
  inviteId: string
): Promise<any> => {
  const response = await callAPI(`/${artistId}/${inviteId}`, 'PUT');

  return await handleResponse(response);
};
